import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import type { ISanityHeadingWithCta } from '../../fragments/sanity-heading-with-cta-parts';
import { classNames } from '../../utils/classnames';
import {
  BG_COLOUR_MAP,
  TEXT_COLOUR_MAP,
} from '../../utils/object-dictionaries';
import { ButtonLink } from '../button-link';

interface HeroProps {
  headingWithCta: ISanityHeadingWithCta;
  title: string;
}
function HeadingWithCta({ headingWithCta, title }: HeroProps): JSX.Element {
  if (!headingWithCta) <div></div>;
  return (
    <div
      className={classNames(
        BG_COLOUR_MAP[headingWithCta.colourScheme],
        TEXT_COLOUR_MAP[headingWithCta.colourScheme],
        'relative'
      )}
    >
      {headingWithCta.heading.length > 1 ? (
        <div>
          <div className="absolute pointer-events-none md:-top-2 md:left-16 xl:left-36 opacity-10">
            <StaticImage
              src="../../images/assets/booked-now.png"
              alt=""
              width={175}
            />
          </div>

          {title === 'Home' && (
            <div className="absolute opacity-50 pointer-events-none bottom-96">
              <StaticImage
                src="../../images/assets/steps-2.png"
                alt=""
                width={400}
              />
            </div>
          )}
        </div>
      ) : (
        <div className="absolute pointer-events-none">
          <StaticImage
            src="../../images/assets/give-a-fun-filled-adventure.png"
            alt=""
            height={165}
            width={1300}
          />
        </div>
      )}
      <div className="w-full px-4 py-12 mx-auto md:w-10/12 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-3 lg:items-center lg:justify-between lg:gap-4">
          <div className="relative text-2xl lg:col-span-2">
            <h2 className="">
              {headingWithCta.heading.map((line, index) => (
                <React.Fragment key={line.id}>
                  <span
                    className={classNames(
                      line.isBold ? 'uppercase font-semibold ' : '',
                      'inline-block leading-tight',
                      headingWithCta.heading.length > 1
                        ? index === 1 && 'font-serif text-5xl md:text-6xl'
                        : 'font-serif text-4xl xl:text-6xl'
                    )}
                  >
                    {line.text}
                  </span>
                  {index !== headingWithCta.heading.length - 1 ? <br /> : null}
                </React.Fragment>
              ))}
            </h2>
          </div>
          <div className="mt-4 lg:mt-0 lg:text-right lg:col-span-1">
            {headingWithCta.ctas
              ? headingWithCta.ctas.map((cta) => (
                  <ButtonLink
                    key={cta.id}
                    link={cta}
                    colourScheme={headingWithCta.colourScheme}
                  />
                ))
              : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export { HeadingWithCta };
